<script setup>
import { computed } from 'vue'
import BaseIcon from '@/components/shared/ui/BaseIcon.vue'

const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  variant: {
    type: String,
    default: 'plain',
    validator: (value) => ['plain', 'success', 'danger', 'neutral'].includes(value)
  },
  bordered: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value)
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const textColors = {
  plain: '',
  success: 'text-green-600',
  danger: 'text-red-600',
  neutral: 'text-gray-600'
}

const borderColors = {
  plain: 'border',
  success: 'border border-green-600 hover:text-white hover:bg-green-600',
  danger: 'border border-red-600 hover:text-white hover:bg-red-600',
  neutral: 'border border-gray-600 hover:text-white hover:bg-gray-600'
}

// Each size maps to a fixed icon font-size and the box used when bordered.
// This is very restrictive but wanted, to keep the buttons more consistent throughout the app.
const sizes = {
  sm: { text: 'text-2xs', box: 'h-6 w-6' },
  md: { text: 'text-xs', box: 'h-7 w-7' },
  lg: { text: 'text-sm', box: 'h-9 w-9' },
  xl: { text: 'text-xl', box: 'h-11 w-11' }
}

const buttonClasses = computed(() => {
  const size = sizes[props.size]
  const classes = [textColors[props.variant], size.text]
  if (props.bordered) {
    classes.push('flex justify-center items-center rounded', size.box, borderColors[props.variant])
  }
  return classes
})
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    class="cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
    :class="buttonClasses"
  >
    <BaseIcon :icon="icon" />
  </button>
</template>
